<template>
  <div class="main">
    <img src="../img/indexbg.jpg" width="100%"/>
    <div class="con">
      <div class="lcon">
        <h1>公司简介</h1>
        <p>北京运多多网络科技有限公司创始于2015年7月，联合创始人均来自阿里巴巴、360公司、百度、摇篮网和SYNNEX等知名公司。</p>
        <p>公司致力于科技、互联网传统相关业务模式，基于互联网思维，为B、C端用户提供服务，旗下产品有京东区域营销、洗爱车、天天向上等知名产品。目前深度合作了京东、阳光海天全国最大洗车服务平台、易车生活、博众博悦等精准的战略伙伴与资源。</p>
      </div>
      <div class="rcon">
        <div class="col">
          <img src="../img/dcode1.jpg" class="dcode"/>
          <p>扫码查看小程序</p>
        </div>
        <div class="col">
          <img src="../img/dcode2.jpg" class="dcode"/>
          <p>扫码关注公众号</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dcode: ''
    }
  },
  methods: {
    getShopDcode(){
      this.$post("/app/v2/shop/shopInfo",{userId: 100445})
        .then((response) => {
          console.log(response);
          this.dcode =  response.data.qrcode
        })
    },
  },
  mounted: function () {
    this.getShopDcode();
    this.$layer.dialog({
      title: ['声明','background:#c00;color:#fff'], // 第一个是标题内容  第二个是标题栏的style(可以为空)
      content: '<p style="text-align: left">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;近期我公司接到多名用户举报，有不法分子打着我公司以前app产品（蜜柚淘）名义进行网络诈骗，其中之一行为是告知用户蜜柚淘是一个基于O2O智能云平台，通过第三方云控主机匹配京东、天猫、淘宝、拼多多、美丽等订单，邀请用户加入平台成为代理获得额外提成奖励等，通过此方法诱引用户消费、汇款等，最终导致用户受骗和财产损失。</p><p style="text-align: left">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本公司声明，我们从未在网络上以短信或以任何形式联系用户进行此类操作！骗子描述的“蜜柚淘”app产品与我公司之前经营的蜜柚淘app事实完全不符，而且我公司早在2017年就已经停止更新维护该产品，并于2019年在苹果应用商店下架了。我们是一家正规且合规的科技公司，相关业务也符合国家法律法规制度，并受到相关部门监管。对于不法分子盗取我公司名义及恶意泄露我公司执照等行为给予严正的谴责，并保留追究当事人法律责任的权利，解决对我公司的不良侵害！</p><p style="text-align: right">特此声明</p><p style="text-align: right">北京运多多网络科技有限公司</p><p style="text-align: right">2021年3月11日</p>',
      contentClass: 'className',
      btn: ['确定'],
      //   time: 2000
    })
      .then(function (res){
        this.$layer.close();
        console.log(position)
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .main {}
  .con {width: 1200px; height: 200px; margin: 0 auto; margin-top: 50px}
  .con .lcon {float: left; width: 500px; font-size: 14px; line-height: 24px; color: #666}
  .con .lcon h1 {font-size: 18px; line-height: 40px; color: #333}
  .con .rcon {float: right; width: 380px; line-height: 0}
  .con .rcon .col {float: left; margin-left: 30px}
  .con .rcon .dcode {width: 160px; height: 160px}
  .con .rcon p {line-height: 30px; font-size: 14px; text-align: center}
</style>



// WEBPACK FOOTER //
// src/components/home.vue